import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import { sharedTransition } from 'remote-com-shared/style/motion';
import styled, { css } from 'styled-components';

import { OverviewLabel } from '@/src/components/OverviewSection';
import { transformProperties, fieldHasContent } from '@/src/domains/prismic/helpers';

export const BaseLinkStyle = css`
  a {
    color: var(--colors-irisBlue);
    border-bottom: 1px solid rgba(20, 25, 30, 0.4);
    ${sharedTransition('border-color')}

    &:hover {
      border-color: var(--colors-irisBlue);
    }
  }
`;

export const BaseWhiteLinkStyle = css`
  a {
    color: var(--colors-blank);
    border-bottom: 1px solid rgba(255, 255, 255, 0.6);
    ${sharedTransition('border-color')}

    &:hover {
      border-color: var(--colors-blank);
    }
  }
`;

export const Section = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '50px', '100px')}
  font-family: var(--typography-fontBrand);
`;

export const Description = styled.div`
  color: rgba(20, 25, 30, 0.75);
  padding: 38px 0;
  ${({ theme }) => theme.typography.titleSM}
  font-weight: 400;
  line-height: 1.55;
  ${BaseLinkStyle}

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const Title = styled.div`
  font-weight: 700;
  ${fluidProp('font-size', '38px', '48px')}
  line-height: 113.5%;
  color: var(--newBrandColor);

  > * {
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
    margin: 0;
  }
`;

const Note = styled(Description)`
  border-top: 1px solid rgba(20, 25, 30, 0.4);
`;

export function ContentSlice({ slice }) {
  const { primary } = transformProperties(slice);

  const { label, title, description, note, sectionId } = primary;

  const defaultTitle =
    'Remote builds belonging for your global team with comprehensive local plans at competitive rates.';
  const defaultDescription =
    'At Remote, we offer country-specific benefits for everyone on your team. Your team members will enjoy comprehensive coverage from top providers while you access competitive rates meant for larger groups — even if you’re still growing!';

  return (
    <Section id={sectionId}>
      <ContentContainer>
        {fieldHasContent(label) && (
          <OverviewLabel>
            <small>{label}</small>
          </OverviewLabel>
        )}

        <Title>{fieldHasContent(title) ? <PrismicRichText field={title} /> : defaultTitle}</Title>
        <Description>
          {fieldHasContent(description) ? (
            <PrismicRichText field={description} />
          ) : (
            defaultDescription
          )}
        </Description>

        {fieldHasContent(note) && (
          <Note>
            <PrismicRichText field={note} />
          </Note>
        )}
      </ContentContainer>
    </Section>
  );
}
